import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-toastify';

import * as settingsAction from "store/entities/settingsInfo/action";
import * as accountActions from "store/auth/account/action";

import pencilIcon from "assets/images/icons/pencil-icon.svg";
import FormDrawer from '../form-drawer';
import { ButtonLoader } from '.';
import { getBusinessInitials } from 'utils/nameInitials.jsx';


const CompanyProfileModal = (props) => {
    const {isOpen, setIsOpen, handleImgUpdate, company} = props;
    
    const [isUpdated, setIsUpdated] =useState(false)
    const [file, setFile] = useState(null);
    const [preview, setPreview] = useState(null);
    const dispatch = useDispatch();
    const { uploadCompanyLogoLoading, uploadCompanyLogo } = useSelector(state => state.entities.settingsInfo);
    
    const companyName = company?.companyName
    
    const fileInputRef = useRef(null);

    const handleWrapperClick = () => {
        fileInputRef.current.click(); // Programmatically trigger the file input click
    };

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setFile(selectedFile);
        if (selectedFile) {
            setPreview(URL.createObjectURL(selectedFile));
        }
    };
    
    const handleRemoveImage = () => { 
        setFile(null);
        setPreview(null);
    }



const submitForm = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('file', file);
        
    if (file) {
        dispatch(settingsAction.uploadCompanyLogo(formData))
        setIsUpdated(true)
    }
}

const handleRemoveLogo = () => {
    handleRemoveImage();
    dispatch(settingsAction.uploadCompanyLogo({}))
    setIsUpdated(true)
}

useEffect(() => {
    setPreview(company?.businessLogo)
}, [company]);

useEffect(() => {   
    if(uploadCompanyLogo?.id && isUpdated) {
        handleImgUpdate(uploadCompanyLogo)
        setIsOpen(false);
        setIsUpdated(false)
        dispatch(accountActions.getEmployerInfo())
        toast.success("Company logo updated successfully");
        dispatch(settingsAction.resetUploadCompanyLogo());
        
    }
    // eslint-disable-next-line
    }, [ uploadCompanyLogo]);
    
    return (
    
        <FormDrawer display="center" size="sm" isOpen={isOpen} setIsOpen={setIsOpen}>
            <form className="p-6">
                <FormDrawer.Title
                    title="Company Logo"
                    description="Add a logo to personalize your company"
                    showCloseButton={true}
                    close={setIsOpen}
                />
                
                <div>
                    <div className='my-8 relative'>
                        <button type='button' onClick={handleWrapperClick} className='flex justify-center mx-auto relative h-[185px] w-[185px] '>
                           { preview ? 
                                (
                                    <button type='button' className='flex justify-center mx-auto'>
                                        <img
                                            src={preview}
                                            alt="Preview"
                                            width="185"
                                            height="185"
                                            className='rounded-full object-cover'
                                            style={{
                                                borderRadius: '50%',
                                                width: '185px',
                                                height: '185px',
                                                objectFit: 'cover',
                                            }}
                                        />
                                    </button>
                                )
                           :
                           <button type='button' className='flex justify-center items-center rounded-full text-center text-white bg-ep-primary p-6'
                            style={{
                                borderRadius: '50%',
                                width: '185px',
                                height: '185px',
                                fontSize: "80px",
                            }}>
                            {getBusinessInitials(companyName)}
                        </button>
                             }
                        </button>
                        
                        <button type='button' className="text-sm font-normal text-white rounded-full w-14 h-14 flex justify-center items-center bg-ep-primary-600 absolute top-0 right-20 z-40 cursor-pointer">
                            <input type="file"  style={{cursor: "pointer!important"}} accept="image/*" onChange={handleFileChange} ref={fileInputRef} className='opacity-0 w-14 h-14 absolute bottom-2 right-1 cursor-pointer' />
                            <img className=' cursor-pointer ' src={pencilIcon} alt="" />
                        </button>
                    </div>
                    
                    <button type="button" onClick={submitForm} disabled={uploadCompanyLogoLoading}>
                        {uploadCompanyLogoLoading && 'Uploading...'}
                    </button>
                    
                    <div className="p-1 mt-4 flex items-center space-x-3">
                        <button 
                            onClick={handleRemoveLogo} 
                            type="button" 
                            className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-ep-primary-600 text-ep-primary-600 bg-white"
                        >
                            Remove
                        </button>
                        <ButtonLoader type="button" loading={uploadCompanyLogoLoading} onClick={submitForm} disabled={uploadCompanyLogoLoading} className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-ep-primary-600 text-white bg-ep-primary-600">
                            Save Changes
                        </ButtonLoader>
                    </div>    
                </div>
            </form>
        </FormDrawer>
  )
}

export default CompanyProfileModal




